/**
 * 快递单模板的类型
 */
enum WaybillTemplateType {
    CAINIAO = "CAINIAO",

    JD = "JD",

    JDL = "JDL",

    NORMAL = "NORMAL",

    OFFICIAL = "OFFICIAL",

    PDD = "PDD",

    JINRITEMAI = "JINRITEMAI",

    TAOBAO_CAINIAO = "TAOBAO_CAINIAO",

    KWAISHOP = "KWAISHOP",

    WEBUY = "WEBUY",

    CHANNEL_SHOP = "CHANNEL_SHOP",

    XIAOHONGSHU = "XIAOHONGSHU",

    AIKUCUN = "AIKUCUN",
}

export default WaybillTemplateType;
